import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, User, Search } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { PageBanner } from "../components/Shared";
import { useContent } from "../context/ContentContext";
import { usePageMeta } from "../hooks/usePageMeta";

const Blogs = () => {
  const { t, lang } = useLang();
  usePageMeta({ title: "Hajj & Umrah Guides and Blog", description: "Practical guides for Bangladeshi pilgrims: Hajj preparation, Umrah tips, packing checklists, visa advice and more from Fly Jannah." });
  const { BLOGS, IMAGES } = useContent();
  const [q, setQ] = useState("");
  useReveal([lang, q]);

  const list = BLOGS.filter((b) => {
    const title = (lang === "en" ? b.title_en : b.title_bn).toLowerCase();
    return title.includes(q.toLowerCase());
  });

  const fmt = (d) =>
    new Date(d).toLocaleDateString(lang === "en" ? "en-US" : "bn-BD", {
      year: "numeric", month: "short", day: "numeric",
    });

  return (
    <div>
      <PageBanner title={t.sec.blog_title} subtitle={t.sec.blog_sub} image={IMAGES.aboutSecondary} />

      <section className="section-pad bg-jannah-cream">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-md mx-auto mb-12 relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-jannah-green/50" size={18} />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder={lang === "en" ? "Search articles..." : "আর্টিকেল খুঁজুন..."}
              className="w-full pl-11 pr-4 py-3 rounded-full border border-jannah-sand bg-white focus:outline-none focus:ring-2 focus:ring-jannah-green/40"
            />
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {list.map((b) => (
              <Link
                key={b.id}
                to={`/blog/${b.slug}`}
                className="reveal card-hover bg-white rounded-2xl overflow-hidden border border-jannah-sand block"
              >
                <div className="h-52 overflow-hidden relative">
                  <img
                    src={b.image}
                    alt={lang === "en" ? b.title_en : b.title_bn}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full btn-gold text-xs font-bold">
                    {lang === "en" ? b.category_en : b.category_bn}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
                    <span className="flex items-center gap-1.5"><Calendar size={13} /> {fmt(b.date)}</span>
                    <span className="flex items-center gap-1.5"><User size={13} /> {b.author}</span>
                  </div>
                  <h3 className="text-xl font-bold text-jannah-green-dark leading-snug">
                    {lang === "en" ? b.title_en : b.title_bn}
                  </h3>
                  <p className="mt-2 text-sm text-muted-foreground line-clamp-2">
                    {lang === "en" ? b.excerpt_en : b.excerpt_bn}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-jannah-green font-semibold text-sm">
                    {t.read_more} <ArrowRight size={15} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
          {list.length === 0 && (
            <p className="text-center text-muted-foreground py-10">
              {lang === "en" ? "No articles found." : "কোনো আর্টিকেল পাওয়া যায়নি।"}
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blogs;
